import type { ReferenceTableRow } from '@repo/commons/models'
import { isBooleanColumnType, serializeManualColumnValue } from './resourceSchemaColumnInput.js'
import type { ResourceSchemaColumnEntry } from './resourceSchemaColumns.js'

export type RowFieldValue = string | boolean

const toFieldValue = (
	[, column]: ResourceSchemaColumnEntry,
	raw: ReferenceTableRow[string] | undefined
): RowFieldValue => {
	if (isBooleanColumnType(column.type)) return raw === true || raw === 'true'

	return raw == null ? '' : String(raw)
}

export const toRowFieldValues = (
	columnEntries: readonly ResourceSchemaColumnEntry[],
	row: ReferenceTableRow | null
): Record<string, RowFieldValue> =>
	Object.fromEntries(
		columnEntries.map((entry) => {
			const [name] = entry

			return [name, toFieldValue(entry, row?.[name])]
		})
	)

export const toReferenceTableRow = (
	columnEntries: readonly ResourceSchemaColumnEntry[],
	fieldValues: Readonly<Record<string, RowFieldValue>>
): ReferenceTableRow =>
	Object.fromEntries(
		columnEntries.map(([name, column]) => {
			const raw = fieldValues[name]

			if (raw === '' || raw == null) return [name, column.nullable === false ? '' : null]

			return [name, serializeManualColumnValue(column.type, raw)]
		})
	)
